import React from "react";
import "./Serviceheader.css";

/**
 * Props:
 *  - bgSrc    : string  -> image path or imported asset
 *  - focusY   : number  -> vertical focus in %, default 35 (shows faces)
 *  - darkness : number  -> 0..1 overlay strength, default 0.45
 *
 * Usage with /public:
 *  <Serviceheader bgSrc="/images/services-header.jpg" />
 *
 * Usage with imported asset:
 *  import hero from "../../assets/services-header.jpg";
 *  <Serviceheader bgSrc={hero} />
 */
export default function Serviceheader({ bgSrc, focusY = 0, darkness = 0.45 }) {
  const fallback = `${process.env.PUBLIC_URL || ""}/hhhr.jpg`;
  const bgUrl = bgSrc || fallback;

  return (
    <section
      className="service-header"
      style={{
        "--service-bg": `url("${bgUrl}")`,
        "--focus-y": `${focusY}%`,
        "--overlay": darkness,
      }}
      aria-label="Services page header"
    >
      <div className="service-header__overlay" aria-hidden="true" />
      <div className="service-header__content">
        <h1 className="service-header__title">SERVICES</h1>
        <span className="service-header__underline" aria-hidden="true" />
      </div>
    </section>
  );
}
